import { swRequest } from "./sw-request";

export const getCampaign = ({ campaignId }) =>
  swRequest({
    path: "/api/campaigns/get",
    method: "GET",
    params: { campaignId },
  });

export const getCampaigns = ({ currentUserOnly, openOnly }, opts = {}) =>
  swRequest(
    {
      path: "/api/campaigns/get_open",
      method: "GET",
      params: { currentUserOnly, openOnly },
    },
    opts,
  );

export const spreadsheetMap = (body) =>
  swRequest({ path: "/api/spreadsheet/map", body, method: "POST" });
